import { Action } from "@ngrx/store";
import { type } from "@play/state";

export const ActionTypes = {
    INIT: type("[App] Init"),
};

export class IntializeAppAction implements Action {
    public type = ActionTypes.INIT;
    constructor() {}
}

export type Actions = IntializeAppAction;
